export default __webpack_public_path__ + "static/media/web.ad9a6165.png";